import { render } from "./InformationExit.vue?vue&type=template&id=4fb5efc7&scoped=true"
import script from "./InformationExit.vue?vue&type=script&lang=js"
export * from "./InformationExit.vue?vue&type=script&lang=js"

import "./InformationExit.vue?vue&type=style&index=0&id=4fb5efc7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb5efc7"]])

export default __exports__